<template>
    <div class="size-full rounded-lg border flex flex-col justify-between p-[12px]">
        <div><h2 class="flex font-extralight items-center gap-x-2">HC Repartition <Info :size="15" strokeWidth="1.3"/></h2></div>
        <div class="h-[310px] w-full">
            <apexchart type="bar" :options="options" :series="series" width="100%" height="310px"></apexchart>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HcRepartition',
    components: {},
    props:['serie'],
    mounted(){
        this.series = this.transformDataForChart(this.serie);
    },
    data(){
        return {
            series: [],
            options:{
                chart: {
                    stacked: true,
                    animations: {
                        enabled: false
                    },
                    toolbar: {  
                    show: false
                    },
                },
            xaxis: {
                categories: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin','Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                labels: {
                    style: {
                            fontWeight: 200,
                            colors: ['#000000']
                        },
                }
            },
            dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:true,
                        fontSize: '8px',
                        fontWeight: 100
                },
            }
        }
    },
    methods:{
        transformDataForChart(data) {
            if (!data || data.length === 0) {
                return [];
            }
            const contractKeys = Object.keys(data[0]).filter(key => key !== 'month');
            const dataBySeries = contractKeys.map(key => ({
                name: key,
                data: []
            }));
            data.forEach(monthData => {
                contractKeys.forEach((key, index) => {
                    const value = typeof monthData[key] === 'number' ? monthData[key] : 0;
                    dataBySeries[index].data.push(value);
                });
            });

        return dataBySeries;}
    }
}
</script>